<div class="flex items-center gap-2 mb-3">
  <h3 class="m-0 text-base font-bold text-midnight flex-grow">eJournal</h3>
  @if (eJournal && !eJournal.isFinal) {
  <button
    class="btn btn-xs btn-outline normal-case rounded-full"
    (click)="onEditEJournal()"
  >
    Edit
  </button>
  }
</div>

<ng-content></ng-content>
